const types = {
    TEST: 'async',
    LOGIN: 'async',
    GET_CURRENT_USER: 'async',
    GET_GAMES: 'async',
    SAVE_NEW_GAME: 'async',
    GET_GAME: 'async',
    SAVE_GAME: 'async',
    OPEN_GAME_EDIT: null,
    OPEN_GAMES_LIST: null,
    LOGOUT: null
};

Object.keys(types).forEach(key => {
    if (types[key] === 'async') {
        types[key] = {
            all: []
        };
        ['REQUEST', 'SUCCESS', 'FAILURE'].forEach(type => {
            const full_type = `${key}_${type}`;
            types[key][type] = full_type;
            types[key].all.push(full_type);
        });
    } else if (types[key] === null) {
        types[key] = key;
    } else {
        throw new Error('type value must be "async" or null');
    }
});


export default types;



// WEBPACK FOOTER //
// ./src/js/actions/types.js